import type { ShiftsReportConfig } from '@/openapi';
import { ReportsService } from '@/openapi';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const partnerShiftsConfigKeys = {
  all: ['partnerShiftsConfig'] as const,
  config: () => [...partnerShiftsConfigKeys.all] as const,
} as const;

export const usePartnerShiftsConfigMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (shiftConfig: ShiftsReportConfig) => {
      return ReportsService.reportsServiceUpdateShiftTotalsConfig({
        body: shiftConfig,
      });
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: partnerShiftsConfigKeys.config(),
      });
    },
  });
};
